export default __webpack_public_path__ + "static/media/Rain of Responding Dragon.adc5f8ab.jpg";